import MapPerspectiveSwitcherItem from './MapPerspectiveSwitcherItem'

export default MapPerspectiveSwitcherItem
